import React, {Component} from 'react';
import PropTypes from 'prop-types';
import OpenFileDialog from "../utils/components/OpenFileDialog";
import BackEnd from "../backend/BackEnd";
import {errorToast} from "../utils/toasts";
import './ImageUploader.css';

class ImageUploader extends Component {
    static propTypes = {
        imageLimit: PropTypes.number,
        onChange: PropTypes.func.isRequired
    };
    static defaultProps = {
        imageLimit: 5
    };
    state = {
        isLoading: true,
        files: []
    };

    render() {
        const {imageLimit} = this.props;
        return (
            <div style={{display: 'flex'}}>
                {this.state.files.map(image =>
                    <div key={image.thumbFileId} className="uploaded-image">
                        <i className="fa fa-times uploaded-image-delete-button"
                            onClick={() => this.deleteImage(image)}/>
                        <img src={image.src} />
                    </div>
                )}
                {
                    this.state.files.length < imageLimit &&
                    <div className="placeholder-image"
                         onClick={() => this.openFileDialog.open()}>
                    </div>
                }
                <OpenFileDialog ref={el => this.openFileDialog = el}
                                accept="image/*" multiple={true}
                                onChange={files => this.uploadImages(files)}/>
            </div>
        );
    }

    async uploadImages(files) {
        const {imageLimit, onChange} = this.props;

        if (files.length === 0)
            return;

        if (this.state.files.length >= imageLimit)
            return;

        files = files.map(file => ({
            name: file.name,
            size: file.size,
            nativeFile: file
        }));

        let invalidSize = files
            .filter(file => file.size > this.maxSize)
            .map(file => file.name);
        if (invalidSize.length > 0) {
            errorToast(`Размер следующих файлов превышает допустимое значение в 30 Мбайт:\n${invalidSize.join('\n')}`);
            return;
        }

        this.setState({isLoading: true});

        const fileLimit = imageLimit < files.length ? imageLimit : files.length;

        for (let i = 0; i < fileLimit; i++) {
            let file = files[i];
            let {originalFileId, thumbFileId} = await this.uploadImage(file);

            this.state.files.push({
                originalFileId,
                thumbFileId,
                name: file.name,
                src: new BackEnd.Documents.ViewImage().createUrl({
                    fileId: thumbFileId
                })
            });
        }

        this.setState({
            isLoading: false,
            files: this.state.files
        });

        onChange(this.state.files.map(file => ({
            originalFileId: file.originalFileId,
            thumbFileId: file.thumbFileId,
            name: file.name
        })));
    }

    uploadImage(file) {
        return new Promise((resolve, reject) => {
            let uploadFile = new BackEnd.Documents.UploadImageFile();
            let fileReader = new FileReader();

            fileReader.onload = () => {
                uploadFile.sendFile(fileReader.result)
                    .then(resolve);
            };

            fileReader.readAsArrayBuffer(file.nativeFile);
        });
    }

    deleteImage(image) {
        const {onChange} = this.props;

        this.setState({
            files: this.state.files.filter(f => f !== image)
        });

        onChange(this.state.files.map(f => f.fileId));
    }
}

export default ImageUploader;


// WEBPACK FOOTER //
// ./src/components/ImageUploader.js